<ng-container *transloco="let t; read: 'accounts'">
<div class="p-5 min-h-screen">
  <div class="flex justify-between">
    <drdp-title [title]="t('permissions.title')"></drdp-title>
    <span class="align-bottom">
      <drdp-btn class=" pr-2" [color]="'outline'" (click)="openFilterDialog()">
        {{ t('permissions.filterRoles') }}
      </drdp-btn>
      <drdp-btn [color]="'outline'" (click)="downloadRoleReport()">{{ t('permissions.export') }}</drdp-btn>
    </span>
  </div>

  @for (group of permissionGroup$ | async; track group) {
    <div class=" pb-6">
      <drdp-permissions-management [group]="group" [roles]="roles" (permissionAssignment)="updatePermission($event)"
        [assignmentList]="assignmentList">
      </drdp-permissions-management>
    </div>
  }
  <drdp-permissions-management [isUncategorized]="true" [uncategorizedList]="uncategorizedList" [roles]="roles" (permissionAssignment)="updatePermission($event)"
    [assignmentList]="assignmentList">
  </drdp-permissions-management>
</div>
</ng-container>